"use client";

import { ComponentProps } from "react";
import TitleH1 from "../fonts/TitleH1";
import BlogImage from "./BlogImage";

type HeaderProps = ComponentProps<typeof BlogImage> & {
  title: string;
  text: string | React.ReactNode;
};

const Header = ({ ...props }: HeaderProps) => {
  return (
    <div className="[--h1-weight:500] [--heading-scale:0.6] gs--blog-header bg-gradient-to-b from-primary to-background">
      <div className="gs--blog-header__inner gs--page-column">
        <TitleH1
          className="gs--blog-header__title"
          title={props.title}
        />
        <div className="gs--blog-header__content">
          <p className="gs--blog-header__text">{props.text}</p>

          <BlogImage
            wrapperClassName="gs--blog-header__image-wrapper"
            className="gs--blog-header__image"
            src={props.src}
            alt={props.alt}
            width={props.width}
            height={props.height}
            style={props.style}
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
